import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import pxToEm from 'styles/pxToEm';

const styles = () => ({
  typography: {
    padding: '55px 45px',
    lineHeight: pxToEm(24, 14),
  },
});

const NarrativeViewDialog = ({
  open,
  onClose,
  Narrative,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogTitle onCloseClick={onClose}>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Narrative
      </Typography>
    </DialogTitle>
    <DialogContent withScrollbars>
      <Typography
        className={classes.typography}
        color="secondary"
      >
        {Narrative.split('\n').map((item, key) => (
          <Fragment
            // eslint-disable-next-line react/no-array-index-key
            key={key}
          >
            {item}<br />
          </Fragment>
        ))}
      </Typography>
    </DialogContent>
  </Dialog>
);

NarrativeViewDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  Narrative: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

NarrativeViewDialog.defaultProps = {
  open: false,
  onClose: () => {},
};

export default withStyles(styles)(NarrativeViewDialog);



// WEBPACK FOOTER //
// ./src/components/workflow/NarrativeViewDialog/NarrativeViewDialog.js